export default __webpack_public_path__ + "static/media/no-screen-share-ild.ce1733b2.png";